import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=128ff16d&scoped=true"
import script from "./Fade.vue?vue&type=script&lang=js"
export * from "./Fade.vue?vue&type=script&lang=js"
import style0 from "./Fade.vue?vue&type=style&index=0&id=128ff16d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ff16d",
  null
  
)

export default component.exports